module.exports = __webpack_public_path__ + "static/img/fe_bw.2cbe643.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fe_bw.png
// module id = SQ9X
// module chunks = 0